import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const Pill = styled.div<{ $pulse?: boolean }>`
  padding: 0.5rem 1rem;
  border-radius: 10rem;
  font-size: 1.2rem;
  transition: background-color 0.2s ease-out, color 0.2s ease-out,
    transform 0.2s ease-in-out;
  cursor: pointer;

  &:active {
    transform: scale(0.97);
  }

  /* Prevents accidental label selection when clicking */
  -webkit-user-select: none;
  user-select: none;

  animation: ${({ $pulse }) =>
    $pulse ? "pulse 2s infinite forwards" : "none"};

  @keyframes pulse {
    0% {
      transform: scale(0.98);
    }
    50% {
      transform: scale(1.02);
    }
    100% {
      transform: scale(0.98);
    }
  }
`;
